export default [
    {
        path: "/admin/account/manage-accounts",
        name: "admin-account-manage-accounts",
        meta: { title: "Manage Account", authRequired: true },
        component: () => import("../views/admin/account/account/AccountTable")
    },
    {
        path: "/admin/account/account-details/:id",
        name: "admin-account-account-details",
        meta: { title: "Manage account", authRequired: true },
        component: () => import("../views/admin/account/account/AccountDetails")
    },

    {
        path: "/admin/influencer/list-influencers",
        name: "admin-influencer-list-influencers",
        meta: { title: "List Influencers", authRequired: true },
        component: () => import("../views/admin/influencer/influencer/InfluencerList")
    },

    {
        path: "/admin/influencer/manage-social-influencers",
        name: "admin-influencer-manage-social-influencers",
        meta: { title: "Manage Socials", authRequired: true },
        component: () => import("../views/admin/influencer/social/SocialTable")
    },
    {
        path: "/admin/influencer/social-details",
        name: "admin-influencer-social-details",
        meta: { title: "Social Details", authRequired: true },
        component: () => import("../views/admin/influencer/social/SocialTable")
    },

    {
        path: "/admin/recruitment/manage-recruitments",
        name: "admin-recruitment-manage-recruitments",
        meta: { title: "Recruitments", authRequired: true },
        component: () => import("../views/admin/recruitment/recruitment/RecruitmentTable")
    },
    {
        path: "/admin/recruitment/candidate/:id",
        name: "admin-recruitment-candidate",
        meta: { title: "Recruitment Candidate List", authRequired: true },
        component: () => import("../views/admin/recruitment/recruitment/CandidateList")
    },
    {
        path: "/admin/recruitment/manage-booking",
        name: "admin-recruitment-manage-booking",
        meta: { title: "Recruitments", authRequired: true },
        component: () => import("../views/admin/recruitment/recruitment/BookingTable")
    },
    {
        path: "/admin/marketing/dashboard",
        name: "admin-marketing-dashboard",
        meta: { title: "Recruitment View", authRequired: true },
        component: () => import("../views/admin/marketing/MarketingDashboard")
    },
    {
        path: "/admin/marketing/tiktok-invitation",
        name: "admin-marketing-tiktok-invitation",
        meta: { title: "Recruitment View", authRequired: true },
        component: () => import("../views/admin/marketing/TiktokInvitation")
    },
]